import { render, staticRenderFns } from "./catalogos-colaboradores-autorizadores.vue?vue&type=template&id=44544ecb&scoped=true&"
import script from "./catalogos-colaboradores-autorizadores.vue?vue&type=script&lang=js&"
export * from "./catalogos-colaboradores-autorizadores.vue?vue&type=script&lang=js&"
import style0 from "./catalogos-colaboradores-autorizadores.vue?vue&type=style&index=0&id=44544ecb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44544ecb",
  null
  
)

export default component.exports